export const EAlert = {
	success: 'success',
	error: 'error',
	warning: 'warning',
}